module.exports = __webpack_public_path__ + "img/island-hopping-full-white.a19761d0.svg";